// This file is AUTOGENERATED, do not edit it manually!!!

export const common = {
    activity: 'Activiteit',
    add_check_list_item_placeholder: 'Checklist item toevoegen of gebruik Ctrl+V om een lijst met items te plakken',
    add_checklist_label: 'Checklist toevoegen',
    add_more: 'Meer toevoegen',
    add_reaction_title: 'Reactie toevoegen',
    ai: 'AI',
    ai_analyzing: 'Analyseren van patronen',
    ai_building: 'Opstellen van prognosemodel',
    ai_description: 'De {brandName} AI-prognose maakt gebruik van machine learning-algoritmen om patronen en relaties tussen gebeurtenissen en acties te vinden door de historische gegevens van uw account te verwerken. Als resultaat laat het de meest waarschijnlijke einddatum van het project zien en het vertrouwen in deze voorspelling.',
    ai_forecast: 'AI-prognose',
    ai_forecast_date: 'AI-voorspelde projecteinddatum',
    ai_how_works: 'Leer meer over hoe AI werkt',
    ai_not_enough_data: 'Niet genoeg historische gegevens om een betrouwbare prognose te maken. Door het systeem actief te gebruiken, zorgt u voor nauwkeurigere prognoses. <a href={0} target=\'_blank\' class={1}>Leer meer</a> over de AI-prognose.',
    ai_planned_date: 'Geplande projecteinddatum',
    ai_result: 'AI-prognose resultaten',
    ai_reviewing: 'Beoordelen van historische gegevens',
    apply: 'Toepassen',
    available: 'Beschikbaar',
    back: 'Terug',
    CanChangeWorkflowForProjectOutdatedData: 'Workflow is al toegepast op het project. Vernieuw de pagina om de gegevens te actualiseren.',
    CanDeleteCategoryHasTask: 'Het is onmogelijk om de categorie te verwijderen die wordt gebruikt in activiteiten.',
    CanDeletePriorityHasProject: 'Het is onmogelijk om de prioriteit te verwijderen die wordt gebruikt in projecten.',
    CanDeletePriorityHasTask: 'Het is onmogelijk om de prioriteit te verwijderen die wordt gebruikt in activiteiten.',
    CanDeletePriorityIsInternal: 'Het is onmogelijk om de interne systeemprioriteit te verwijderen.',
    CanDeleteStatusIsWorkflowTypeStatus: 'Het is onmogelijk om de standaardstatus te verwijderen.',
    CanDeleteStatusUsed: 'Het is onmogelijk om de status te verwijderen die in een entiteit wordt gebruikt.',
    CanDeleteThresholdIsInternal: 'Het is onmogelijk om de interne systeemdrempel te verwijderen.',
    CanDeleteVacationTypeDefault: 'Het is onmogelijk om de standaard vakantietype te verwijderen.',
    CanDeleteVacationTypeHasVacation: 'Het is onmogelijk om het vakantietype te verwijderen waaraan vakantie is toegewezen.',
    CanDeleteWorkflowIsSingle: 'Er moet minstens één workflow in het systeem zijn.',
    CanDeleteWorkflowIsUsed: 'Het is onmogelijk om de workflow te verwijderen die wordt gebruikt in projecten.',
    CanDisableStatusIsUsed: 'Het is onmogelijk om de status uit te schakelen die in een entiteit wordt gebruikt.',
    CanDisableStatusIsWorkflowTypeStatus: 'Het is onmogelijk om de standaardstatus uit te schakelen.',
    CanEdit_Task_AccessDenied: 'U heeft geen toestemming om deze activiteit te bewerken.',
    CanEditValueThresholdIsInternal: 'De ingestelde systeemdrempelwaarden kunnen niet worden gewijzigd.',
    CanSetWorkflowTypeStatusIsWorkflowTypeStatus: 'Het is onmogelijk om de status als standaard te markeren voor reeds standaardstatus.',
    change: 'veranderen',
    ChangeProjectProgressError: 'De voortgang van een project met taken kan niet worden bewerkt.',
    ChangeTaskProgressError: 'De voortgang van een ouderstaak kan niet worden bewerkt.',
    check_all_label: 'Alles selecteren',
    checklist_name: 'Checklist',
    column_group_custom_fields: 'Aangepaste velden',
    column_group_custom_fields_user: 'Gebruikers aangepaste velden',
    columns: 'Kolommen',
    Completed_Projects: 'Voltooide projecten',
    Completed_Tasks: 'Voltooide activiteiten',
    Copy_Text: 'Kopiëren',
    copyPostfix: 'Kopiëren',
    create: 'Maken',
    created_by: 'Gemaakt door',
    creation_date: 'Creatiedatum',
    current_plan: 'Huidig plan: <b>{0}</b>',
    dates: 'Datums',
    delete_checklist_label: 'Checklist verwijderen',
    description_title: 'Beschrijving',
    edit_check_list_item_placeholder: 'Checklist item bewerken',
    Edit_Text: 'Bewerken',
    emoji: 'Emoji',
    empty_list: 'Er zijn geen resultaten gevonden die overeenkomen met de zoekopdracht/filter.',
    error_reload: '{brandName} versie is bijgewerkt. Voor de juiste werking van de applicatie moet u de pagina opnieuw laden.',
    export: 'Exporteren',
    export_csv: 'Exporteren naar CSV',
    export_pdf: 'Exporteren naar PDF',
    filters: 'Filters',
    freeze: 'Kolom bevriezen',
    from: 'Van',
    general: 'Algemeen',
    global_search: 'Zoeken',
    global_search_text: 'Berichten, bestanden en meer zoeken',
    GotIt: 'Begrepen',
    group_by: 'Groeperen op',
    group_by_template: 'Groeperen op: {0}',
    here: 'hier',
    hourly_rate_unit: '/uur',
    icons: 'Iconen',
    in: 'in',
    in_use: 'In gebruik',
    items_text: '1#{0} item#{0} items',
    job_role: 'Functie',
    label_custom_date_range: 'Aangepast datumbereik',
    label_daily: 'Dagelijks',
    label_monthly: 'Maandelijks',
    label_weekly: 'Wekelijks',
    label_yearly: 'Jaarlijks',
    least_likely: 'Minst waarschijnlijk',
    month: 'Maand',
    MoreActions: 'Meer acties',
    most_likely: 'Meest waarschijnlijk',
    move_down: 'Naar beneden verplaatsen',
    move_up: 'Omhoog verplaatsen',
    name_title: 'Naam',
    next_month: 'Volgende maand',
    next_week: 'Volgende week',
    no: 'Nee',
    no_available_filters: 'Geen beschikbare waarden voor filter.',
    no_data_to_display: 'Geen gegevens om weer te geven.',
    no_data_to_display_for_widget: 'Geen gegevens om weer te geven. Filters, inclusief zowel widget-specifieke als algemene filters, kunnen voorkomen dat gegevens worden weergegeven.',
    NoPermissionToArchiveProject: 'Gevraagde actie (project archiveren) is niet beschikbaar om de volgende reden: U heeft geen toestemming om project te archiveren.',
    not_calculated: 'Niet berekend',
    not_in_use: 'Niet in gebruik',
    pause: 'Pauze',
    PortfolioLimitError: 'U heeft het limiet van 60 portefeuilles bereikt in Team Edition. Upgrade naar {brandName} Enterprise Edition.',
    previous_month: 'Vorige maand',
    previous_week: 'Vorige week',
    previous_year: 'Vorig jaar',
    qb_disconnect_denied: 'U heeft geen QuickBooks-token gekoppeld aan dit account.',
    quarter: 'Kwartaal',
    quick_search_placeholder: 'Zoeken op ID of naam',
    quick_search_placeholder_for_archive: 'Zoek gearchiveerde projecten op naam of ID',
    RateLimitExceededByAccount: 'Onze excuses voor het ongemak, maar vanwege hoge verkeersdrukte beperken we momenteel het aantal verzoeken dat u kunt doen. Probeer het later opnieuw.',
    RateLimitExceededByUser: 'Onze excuses voor het ongemak, maar vanwege hoge verkeersdrukte beperken we momenteel het aantal verzoeken dat u kunt doen. Probeer het later opnieuw.',
    read_more: 'Meer informatie',
    RecordConversionToActivityDifferentWorkflows: 'Het is onmogelijk om de record te converteren, omdat verschillende workflows zijn toegepast op het project en de sjabloon.',
    remove_checklist_item_label: 'Checklist-item verwijderen',
    request_resources: 'Middelen aanvragen',
    reset_timer_title: 'Timer resetten',
    resource_type_label: 'Type resource',
    resume: 'Hervatten',
    role: 'Rol',
    schedule_hours: 'Geplande uren',
    security_group: 'Toegangsniveau',
    select: 'Selecteren',
    share: 'Delen',
    short_quarter0: 'K1',
    short_quarter1: 'K2',
    short_quarter2: 'K3',
    short_quarter3: 'K4',
    show: 'Weergeven',
    show_template: 'Weergeven: {0}',
    skillsDeleteConfirm: 'De vaardigheid wordt verwijderd uit profielen van andere gebruikers en functies, waar deze wordt gebruikt.',
    SnapshotsLimitError: 'U heeft het maximum van 3 project-snapshots bereikt. Upgrade naar {brandName} Enterprise Edition.',
    sort: 'Sorteren',
    sort_activities: 'Sorteer activiteiten op:',
    sort_ascending: 'Oplopend sorteren',
    sort_az: 'Oplopend sorteren op A→Z',
    sort_descending: 'Aflopend sorteren',
    sort_projects: 'Sorteer projecten op:',
    sort_resources: 'Sorteer resources op:',
    sort_za: 'Aflopend sorteren op Z→A',
    start: 'Starten',
    start_analyze: 'Start analyse',
    start_new_project: 'Nieuw project starten',
    stop_timer_title: 'Timer stoppen',
    sub_features_list_title: 'Deze functie omvat:',
    SystemTaskCreatorName: 'Systeem',
    Task_CanAccessBillingInformation_AccessDenied: 'U heeft geen toestemming om de factureringsinstellingen van deze activiteit te bewerken.',
    this_month: 'Deze maand',
    this_week: 'Deze week',
    this_year: 'Dit jaar',
    ThresholdValueDuplicate: 'Deze drempelwaarde is al toegevoegd.',
    TimeoutErrorMessage: 'Uw verzoek is verlopen. Probeer het later opnieuw.',
    to: 'Tot',
    today: 'Vandaag',
    uncheck_all_label: 'Alles deselecteren',
    unfreeze: 'Kolom ontdooien',
    UnknownErrorMessage: 'Sorry, er is iets misgegaan... Vernieuw de pagina.',
    upgrade: 'Upgraden',
    upgrade_to_enterprise: 'Upgraden naar Enterprise',
    usage: 'Gebruik',
    week: 'Week',
    WindowUnload_UnsavedChanges: 'Er zijn niet-opgeslagen wijzigingen. Weet u zeker dat u deze pagina wilt verlaten?',
    year: 'Jaar',
    yes: 'Ja',
    yesterday: 'Gisteren',
};
